import React, { useCallback } from "react";
import { FiAtSign } from "react-icons/fi";
import { addHttpToLink } from "../../../../Utils/StayUpToDate/RenderComponent";

const getSvgFromEvent = (e: any) => {
  const current = e.currentTarget;
  if (!current) return null;
  if (current.tagName?.toLowerCase() === "svg") return current;
  return current.querySelector?.("svg") || e.target?.closest?.("svg") || null;
};

export const PostInfoTaggedLink = (props: any) => {
  const {
    tagged_link,
    post_id,
    media_url,
    handleTagged,
    platform,
    user_id,
    name,
    designTokens,
    socialIconColor,
  } = props;

  const secondaryFontFamily = designTokens?.secondaryFontFamily;
  const iconColor = socialIconColor || "#000";

  const handleMouseEnter = useCallback((e: any) => {
    const svg = getSvgFromEvent(e);
    if (!svg) return;
    (svg as SVGElement).style.color = "#888";
  }, []);

  const handleMouseLeave = useCallback(
    (e: any) => {
      const svg = getSvgFromEvent(e);
      if (!svg) return;
      (svg as SVGElement).style.color = iconColor;
    },
    [iconColor]
  );

  return (
    <>
      {tagged_link ? (
        <a
          href={addHttpToLink(tagged_link)}
          // Always open in a new tab. Using `_self` on mobile navigated the current tab
          // away to the tagged link, so returning re-booted the whole SPA — perceived as a
          // "random page reload" after tapping a post. Matches the shop/permalink links.
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            verticalAlign: "middle",
            textDecoration: "none",
            outline: "none",
            border: "none",
            ...(secondaryFontFamily ? { fontFamily: secondaryFontFamily } : {}),
          }}
        >
          <FiAtSign
            className="perma-links"
            style={{
              color: iconColor,
            }}
            // onMouseEnter={handleMouseEnter}
            // onMouseLeave={handleMouseLeave}
            onClick={() =>
              handleTagged(post_id, media_url, platform, name, user_id)
            }
          />
        </a>
      ) : (
        ""
      )}
    </>
  );
};
